const PLAYER_KEY = 'crazy-clock-player-v1';
const PLAYER_PATTERN = /^p_[a-f0-9]{32}$/;

let cached: string | null = null;

function randomHex(bytes: number): string {
  const buffer = new Uint8Array(bytes);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(buffer);
  } else {
    let seed = Date.now() >>> 0;
    for (let i = 0; i < buffer.length; i++) {
      seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
      buffer[i] = seed & 255;
    }
  }
  return Array.from(buffer, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function playerId(): string {
  if (cached) {
    return cached;
  }
  try {
    const stored = window.localStorage.getItem(PLAYER_KEY);
    if (stored && PLAYER_PATTERN.test(stored)) {
      cached = stored;
      return stored;
    }
  } catch {
    cached = `p_${randomHex(16)}`;
    return cached;
  }
  const created = `p_${randomHex(16)}`;
  cached = created;
  try {
    window.localStorage.setItem(PLAYER_KEY, created);
  } catch {
    return created;
  }
  return created;
}
